import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Table, Button } from 'reactstrap';
import {useNavigate } from 'react-router-dom'
import { getClientLeads } from '../../../../../../redux/actions/client';
import { STATE_OPTIONS } from '../../../../../Lead/constants';

function LeadData({ clientId }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const leadState = useSelector((state) => state.client.getLeads);

  const getStateLabel = (stateValue) => {
    const stateOption = STATE_OPTIONS.find(
      (option) => option.value === stateValue,
    );
    return stateOption ? stateOption.label : stateValue;
  };

  useEffect(() => {
    if (clientId) {
      dispatch(getClientLeads(clientId));
    }
  }, [clientId, dispatch]);

  const handleViewLead = (leadId) => {
    navigate('/lead-board');
  };

  if (!leadState?.data) {
    return <div>Cargando leads...</div>;
  }

  return (
    <>
      <h4 className="mt-0">Leads</h4>
      <Table hover>
        <thead>
          <tr>
            <th>Número Interno</th>
            <th>Estado</th>
            <th>Vendedor Asignado</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          {leadState.data.length > 0 ? (
            leadState.data.map((lead) => (
              <tr key={lead.id}>
                <td>{lead.data?.holdingId || '--'}</td>
                <td>{getStateLabel(lead.data?.state) || '--'}</td>
                <td>{lead.data?.assigned?.name || '--'}</td>
                <td>
                  <Button
                    color="primary"
                    size="sm"
                    onClick={() => handleViewLead(lead.id)}
                  >
                    Ver Lead
                  </Button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="4" className="text-center">
                No hay leads disponibles
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </>
  );
}

export default LeadData;
